export default {
	active: function() {
		return this.$store.getters.burgerActive;
	},
};
